import Routes from 'Routes';
import { saveOldLocation } from '../../modules/actions';

export default store => ({
  path: Routes.ticket.child.facemoreQurey.key,
  onEnter(nextState, replace, callback) {
    const {
      location: { query },
    } = nextState;
    window.$sensors.sensors.track(
      'flight_ticket_refund_and_change_page_view',
      {
        page_name: '机票退改-码上改签查询页',
        channel_id: query.channel ? query.channel : '',
      }
    );
    callback();

  },
  onLeave(prevState) {
    store.dispatch(saveOldLocation(prevState.location));
  },
  getComponent(nextState, cb) {
    require.ensure(
      [],
      require => {
        const facemoreQurey = require('./components/facemoreQurey').default;
        cb(null, facemoreQurey);
      },
      'facemoreQurey'
    );
  },
});



// WEBPACK FOOTER //
// ./src/routes/routes/facemoreQurey/index.js